module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 's0f9p4v3',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
